<template>
  <div class="module-release-flow-detail">
    <Card shoaw>
      <Row :style="{marginBottom: '10px'}">
        <div :style="{float: 'left'}">
          <Button size="small" icon="ios-arrow-back" @click="$router.push({name: 'moduleReleaseFlow', query: { page: $route.query.lastPage }})">返回列表</Button>
        </div>
      </Row>
      <Card shadow class="content workflow-module-detail-content">
        <div class="main">
          <div>
            <Row style="margin-bottom: 10px">
              <Col :xs="24" :sm="24" :md="24" :lg="15">
                <Row class="title">
                  <h4 :style="{float: 'left'}">模块申请详情</h4>
                </Row>
                <Alert v-if="moduleInfoError" type="warning" show-icon>获取数据失败</Alert>
                <div class="info-property" v-else>
                  <dl>
                    <dt>申请人</dt><dd v-if="moduleInfo.applicant">{{ moduleInfo.applicant.name ?
                    moduleInfo.applicant.name : moduleInfo.applicant.username }}</dd>
                  </dl>
                  <dl>
                    <dt>模块名</dt><dd>{{ moduleInfo.name }}</dd>
                  </dl>
                  <dl>
                    <dt>描述</dt><dd>{{ moduleInfo.description }}</dd>
                  </dl>
                  <!--<dl>-->
                    <!--<dt>项目经理</dt>-->
                    <!--<dd><Tag v-for="item in moduleInfo.masters" :key="item.id">{{ item.name ? item.name : item.username }}</Tag></dd>-->
                  <!--</dl>-->
                  <!--<dl>-->
                    <!--<dt>产品经理</dt>-->
                    <!--<dd><Tag v-for="item in moduleInfo.pms" :key="item.id">{{ item.name ? item.name : item.username }}</Tag></dd>-->
                  <!--</dl>-->
                  <dl>
                    <dt>开发人员</dt>
                    <dd><Tag v-for="item in moduleInfo.developers" :key="item.id">{{ item.name ? item.name : item.username }}</Tag></dd>
                  </dl>
                  <!--<dl>-->
                    <!--<dt>测试人员</dt>-->
                    <!--<dd><Tag v-for="item in moduleInfo.tests" :key="item.id">{{ item.name ? item.name : item.username }}</Tag></dd>-->
                  <!--</dl>-->
                  <!--<dl>-->
                    <!--<dt>运维人员</dt>-->
                    <!--<dd><Tag v-for="item in moduleInfo.maintain" :key="item.id">{{ item.name ? item.name : item.username }}</Tag></dd>-->
                  <!--</dl>-->
                  <dl v-if="moduleInfo.created_at">
                    <dt>申请时间</dt><dd>{{ moment(moduleInfo.created_at).format('YYYY-MM-DD HH:mm:ss') }}</dd>
                  </dl>
                  <dl v-if="moduleInfo.approve_at">
                    <dt>审批完成时间</dt><dd>{{ moment(moduleInfo.approve_at).format('YYYY-MM-DD HH:mm:ss') }}</dd>
                  </dl>
                  <dl>
                    <dt>状态</dt><dd><span>{{ moduleInfo.status_verbose }}</span></dd>
                  </dl>
                </div>
                <Row className="margin-top-10">
                  <Row class="title">
                    <h4>审批</h4>
                  </Row>
                  <Approves :approves="moduleInfo.approves" approveType="module_release" :reFresh="this.handleReFresh" :status="moduleInfo.status"/>
                </Row>
              </Col>
              <Col span="24" :md="{ span: 6, offset: 1 }">
                <div class="title" >
                  <h4>日志信息</h4>
                </div>
                <FlowLogs :logs = "moduleInfo.logs" />
              </Col>
            </Row>
          </div>
        </div>
      </Card>
    </Card>
  </div>
</template>

<script>
import moment from 'moment'
import { detailModuleReleaseFlow } from '@/api/workflow/module_release_flow'
import FlowLogs from '../components/Logs'
import Approves from '../components/Approves'

export default {
  name: 'detail',
  components: {
    FlowLogs,
    Approves
  },
  data () {
    return {
      moment: moment,
      moduleInfo: {},
      moduleInfoError: false
    }
  },
  created: function () {
    this.init()
  },
  watch: {
    '$route' () {
      if (this.$route.params.id) {
        this.init()
      }
    }
  },
  methods: {
    // 初始化
    init () {
      this.getData()
    },
    // 获取工作流信息
    getData () {
      detailModuleReleaseFlow(this.$route.params.id).then(res => {
        this.moduleInfo = res.data
        this.moduleInfoError = false
      }).catch(res => {
        console.log(res.response)
        this.moduleInfoError = true
      })
    },
    // 处理刷新操作
    handleReFresh () {
      this.init()
    }
  }
}
</script>

<style lang="less">
  @import '../../base.less';
</style>
